import { render, staticRenderFns } from "./Exhibits.vue?vue&type=template&id=c911a07a"
import script from "./Exhibits.vue?vue&type=script&lang=ts"
export * from "./Exhibits.vue?vue&type=script&lang=ts"
import style0 from "./Exhibits.vue?vue&type=style&index=0&id=c911a07a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports